import React from "react"
import classes from "./Controls.module.css"
import { useTranslation } from "react-i18next"

const Controls = props => {
    const { t } = useTranslation()

    return (
        <div className={classes.Wrapper}>
            <div>
                {props.haskey && !props.gearDisabled ? (
                    <button className={classes.Button} onClick={props.startSearchFast}>
                        {t("misc:Recovery.ButtonSearch")} ({t("misc:Recovery.Fast")})
                    </button>
                ) : (
                    <button className={classes.Button} onClick={props.startSearch}>
                        {t("misc:Recovery.ButtonSearch")}
                    </button>
                )}
                <button className={classes.Button} onClick={props.updateGear} disabled={props.gearDisabled}>
                    {t("misc:Recovery.ButtonUpdate")}
                </button>
                {props.haskey && !props.gearDisabled ? null : (
                    <button className={classes.Button} onClick={props.refineSearch} disabled={props.refineDisabled}>
                        {t("misc:Recovery.ButtonRefine")}
                    </button>
                )}
            </div>
        </div>
    )
}

export default React.memo(Controls)
